import axios from "axios";
import { useNavigate } from "react-router-dom";
import API from "../_helpers/endpointService";
export const getprojectpbddocinfo = (data, id) => {
  let apiUrl = API.PBD_LISTVIEW + "?projectId=" + id + "&Description=" + data.Description + "&DateTimeFrom=" + data.DateTimeFrom + "&DateTimeTo=" + data.DateTimeTo + '&PageNumber=' + data.PageNo + '&PageSize=' + data.PageSize;
  return (dispatch) => {
   dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
      dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "PBDLIST_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const downloadsinglepbddocs = (data) => {
  let apiUrl = API.PBD_LISTVIEW + '/key?key=' + data.ObjectKey;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = data.FileName;
          a.click();
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const deletemulitipbddocs = (data, id) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }
  let apiUrl = API.PBD_LISTVIEW + '/ids?' + ids;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const filedeletepbd = (id, name) => {
  let apiUrl = API.PBD_LISTVIEW + '/' + id + '?key=' + name;
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const addpbddocumentinfo = (data, id, modify) => {
  let apiUrl = API.PBD_LISTVIEW + id + '?modify=' + modify
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "UPLOAD_DOCS", data: [] });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const addpbddocinfo = (data, formData) => {
  let apiUrl = API.PBD_LISTVIEW;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch(adduploadpbddocinfo(formData, response.data))
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const putpbddocinfo = (data, formData, id, array) => {
  let apiUrl = API.PBD_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          if (array.length > 0) {
            dispatch(adduploadpbddocinfo(formData, id))
          }
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const adduploadpbddocinfo = (data, id) => {
  let apiUrl = API.PBD_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const pbdlookupdescription = () => {
  let apiUrl = API.LOOKUP_DESCPBD;
  return (dispatch) => {
    axios({
      method: "get",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "LOOKUP_PBDDESC", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};


export const geteditpbddocinfo = (id) => {
  let apiUrl = API.PBD_LISTVIEW + '/' + id
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "PBDEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const gethistorylogpbddocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=PreBeaching'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};